import React, { useState } from "react";
import List from "../workingPartList";
import FrontendTable from "../workingPartFrontendTable";
import Filter from "../workingPartFilter";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import Breadcrumb from "../../../utils/breadCrumbs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ButtonShowError } from "./workingPartFilterList.styled";
import * as WorkingPartServices from "../../../../services/WorkingPartServices";
import * as GeneralServices from "../../../../services/GeneralServices";

const queryClient = new QueryClient();

const WorkingPartFilterListContainer = (props) => {
  const { t } = useTranslation();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.workingPartSnap.title") },
  ];
  const [filters, setFilters] = useState({ showError: false });
  const [showError, setShowError] = useState(false);
  const [allData, setAllData] = useState([]);
  const [loadingAllData, setLoadingAllData] = useState(false);
  const navigate = useNavigate();

  // Función para cargar todos los datos sin paginación
  const loadAllData = async () => {
    setLoadingAllData(true);
    try {
      const filter = {
        page: 1,
        pageSize: 9999, // Número grande para obtener todos
      };
      if (filters) {
        filter.filters = filters;
      }
      const result = await WorkingPartServices.getAllSnapshots(filter);
      setAllData(result || []);
    } catch (error) {
      console.error("Error al cargar todos los datos:", error);
      setAllData([]);
    } finally {
      setLoadingAllData(false);
    }
  };

  // Cargar datos cuando cambian los filtros
  React.useEffect(() => {
    loadAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters({ showError });
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  const goToRegister = () => {
    // navigate(PATHS.GENERATE_ACCOUNT_LINKS);
  };

  const handlerFilterEmployee = async (value) => {
    let filter = {
      filters: {
        companyCode: value,
      },
    };
    let result = await GeneralServices.listFilterVisualEmployees(filter);
    return result;
  };

  return (
    <>
      <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.workingPartSnap.title")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            onFilterEmployee={handlerFilterEmployee}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>

      {/* Nueva tabla con paginación frontend */}
      {/* <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11">
          <h4 className="title mb-3">
            {t("forms.workingPartSnap.frontendTable.title") ||
              "Tabla con paginación frontend"}
          </h4>
          {loadingAllData ? (
            <div className="text-center p-4">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : (
            <FrontendTable data={allData} />
          )}
        </div>
      </div> */}

      {/* <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 text-center">
          <button className="btn btn-secondary" onClick={() => goToRegister()}>
            {t("forms.workingPartSnap.buttons.new")}
          </button>
        </div>
      </div> */}
    </>
  );
};

WorkingPartFilterListContainer.propTypes = {};

export default WorkingPartFilterListContainer;
